var Backbone = require('backbone');
var _ = require('underscore');

var Base = require('front/components/Base/Base');

require('./SideNav.less');

module.exports = Base.extend({
    template: require('./SideNav.jinja'),

    el: '.SideNav',

    events: {
        'click .SideNav-item--withSub': 'showSubnav',
        'click .SideNav-subnav .SideNav-close': 'closeSubnav',
        'click .SideNav-item--sub': 'onSubNavItemClick',
        'click .SideNav-item a': 'onNavLinkClick',
        'click .SideNav-desc': 'show',
        'click .SideNav-nav .SideNav-close': 'hide'
    },

    initialize: function (options) {
        _.bindAll(this, 'activateSubNav', 'closeSubnav', 'activateSubPage', 'deactivateSubPage', 'activateIndex',
            'deactivateIndex', 'hideNav');
        this.options = options || {};
        this.subnavIsVisible = false;
        this.$subItems = this.$('.SideNav-item--sub');
        this.navType = '';
        this.isHidden = false;
        this.isIndex = false;
        this.isSubPage = false;

        this.on('activateSubNav', this.activateSubNav);
        app.vent.on('activateIndex', this.activateIndex);
        app.vent.on('deactivateIndex', this.deactivateIndex);
        app.vent.on('activateSubPage', this.activateSubPage);
        app.vent.on('deactivateSubPage', this.deactivateSubPage);
    },

    showSubnav: function (e) {
        var $target = $(e.target);

        this.$('.SideNav-item--isActive').removeClass('SideNav-item--isActive');

        if (this.subnavIsVisible) {
            $target.addClass('SideNav-item--isActive');
            this.$el.removeClass('SideNav--' + this.navType);
            this.navType = $target.data('url');
            this.$el.addClass('SideNav--' + this.navType);

            return;
        }

        this.navType = $target.data('url');
        this.$el.addClass('SideNav--' + this.navType);

        this.subnavIsVisible = true;
        this.$el.addClass('SideNav--sub');
        $target.addClass('SideNav-item--isActive');

        app.vent.trigger('SideNav.subnavShow');
    },

    closeSubnav: function () {
        if (app.settings.isMobile && !this.isIndex) {
            this.hideNav();

            if (this.isSubPage) return;
        }

        this.subnavIsVisible = false;

        this.$el.removeClass('SideNav--sub');
        this.$('.SideNav-item--sub.SideNav-item--isActive').removeClass('SideNav-item--isActive');

        setTimeout(function () {
            this.$el.removeClass('SideNav--' + this.navType);
        }.bind(this), 600);

        app.vent.trigger('SideNav.subnavHide');
    },

    onSubNavItemClick: function (e) {
        var $target = $(e.target);
        var url = '/' + this.navType + '/' + $target.data('url') + '/';

        this.$('.SideNav-item--sub.SideNav-item--isActive').removeClass('SideNav-item--isActive');
        $target.addClass('SideNav-item--isActive');

        this.hideNav();

        Backbone.history.navigate(url, {trigger: 'true'});
    },

    onNavLinkClick: function (e) {
        var $target = $(e.target);

        this.isIndex = false;
        this.isSubPage = false;

        this.closeSubnav();

        this.$('.SideNav-item--isActive').removeClass('SideNav-item--isActive');

        $target.closest('.SideNav-item').addClass('SideNav-item--isActive');
    },

    activateSubNav: function () {
        this.subnavIsVisible = true;
        this.navType = this.$el.data('navtype');
    },

    activateSubPage: function () {
        this.$el.addClass('SideNav--subPage');
        this.isSubPage = true;
    },

    deactivateSubPage: function () {
        this.$el.removeClass('SideNav--subPage');
        this.$el.removeClass('SideNav--isOpened');
        this.isSubPage = false;
        this.closeSubnav();
        this.hideNav();
    },

    activateIndex: function () {
        this.$el.removeClass('SideNav--isOpened');
        this.$('.SideNav-item--isActive').removeClass('SideNav-item--isActive');
        this.isIndex = true;
        this.closeSubnav();
        this.hideNav();
    },

    deactivateIndex: function () {
        this.isIndex = false;
    },

    hideNav: function () {
        this.$el.addClass('SideNav--isHidden');
        this.isHidden = true;
    },

    show: function () {
        this.$el.removeClass('SideNav--isHidden');
    },

    hide: function () {
        this.$el.addClass('SideNav--isHidden');
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/SideNav/SideNav.js
// module id = 38
// module chunks = 0